export default "__VITE_ASSET__CVLsHUix__"